import { Injectable, signal } from "@angular/core";
import { AppSettingsNavigationCategoryExtension } from "@geolib/geoappbase-client";

@Injectable({ providedIn: "root" })
export default class GeobusDataExtension extends AppSettingsNavigationCategoryExtension {

    public isEnabled(): boolean {
        return true;
    }

    public name = signal("data").asReadonly();

    public label = signal("SIDE_MENU.DATA.CATEGORY").asReadonly();

}
